import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_sales_rep_allowed_brand_details: { message: "idle" },
};

export const retrieve_sales_rep_allowed_brand_details_Slice = createSlice({
 name: "retrieve_sales_rep_allowed_brand_details",
 initialState,
 reducers: {
  success_retrieve_sales_rep_allowed_brand_details: (state, action) => {
   state.retrieve_sales_rep_allowed_brand_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_sales_rep_allowed_brand_details: (state, action) => {
   state.retrieve_sales_rep_allowed_brand_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_sales_rep_allowed_brand_details: (state) => {
   state.retrieve_sales_rep_allowed_brand_details = { status: app_consts.IDLE };
  },
  loading_retrieve_sales_rep_allowed_brand_details: (state) => {
   state.retrieve_sales_rep_allowed_brand_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_sales_rep_allowed_brand_details, fail_retrieve_sales_rep_allowed_brand_details, reset_retrieve_sales_rep_allowed_brand_details, loading_retrieve_sales_rep_allowed_brand_details } = retrieve_sales_rep_allowed_brand_details_Slice.actions;

export default retrieve_sales_rep_allowed_brand_details_Slice.reducer;